module.exports = __webpack_public_path__ + "static/media/edit_window.7ecb21e6.svg";